import { render } from "./MovingDotsBackground.vue?vue&type=template&id=15917ea7&scoped=true"
import script from "./MovingDotsBackground.vue?vue&type=script&lang=js"
export * from "./MovingDotsBackground.vue?vue&type=script&lang=js"

import "./MovingDotsBackground.vue?vue&type=style&index=0&id=15917ea7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15917ea7"]])

export default __exports__